import React from "react";

const STEPS = [
    {
        n: "1",
        title: "Candidate en ligne",
        text: "Remplis le formulaire de candidature. Décris ton réseau et ta zone d'activité.",
    },
    {
        n: "2",
        title: "Entretien de qualification",
        text: "Un responsable CapDistrib échange avec toi pour valider ton profil et définir ton niveau.",
    },
    {
        n: "3",
        title: "Accès à ton espace partenaire",
        text: "Contrat signé électroniquement, accès dashboard, kit commercial et catalogue disponibles immédiatement.",
    },
    {
        n: "4",
        title: "Développe et touche tes commissions",
        text: "Tu signes tes premiers réseaux, ils génèrent du volume, tu es commissionné automatiquement chaque mois.",
    },
];

export default function HowItWorks() {
    return (
        <section
            id="comment"
            className="relative py-24 sm:py-32 bg-cap-inkSoft text-white overflow-hidden"
            data-testid="how-section"
        >
            <div className="absolute inset-0 bg-grid opacity-50 pointer-events-none" />
            <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[640px] h-[400px] rounded-full bg-cap-violet/20 blur-[140px]" />

            <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="max-w-3xl">
                    <p className="fade-up eyebrow">Comment ça marche ?</p>
                    <h2
                        className="fade-up h-display text-3xl sm:text-4xl lg:text-[56px] font-bold mt-4"
                        style={{ animationDelay: "0.05s" }}
                        data-testid="how-title"
                    >
                        Quatre étapes pour{" "}
                        <span className="text-violet-glow">démarrer</span>.
                    </h2>
                    <p
                        className="fade-up mt-6 text-lg text-white/65 leading-relaxed"
                        style={{ animationDelay: "0.1s" }}
                    >
                        Un processus simple, rapide et sans engagement initial.
                    </p>
                </div>

                <div className="mt-16 relative">
                    {/* Connecting line on desktop */}
                    <div className="hidden lg:block absolute top-10 left-[10%] right-[10%] h-px bg-gradient-to-r from-transparent via-cap-violet/40 to-transparent" />

                    <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-7">
                        {STEPS.map((s, i) => (
                            <div
                                key={s.n}
                                className="fade-up relative"
                                style={{ animationDelay: `${0.08 * i + 0.1}s` }}
                                data-testid={`how-step-${i}`}
                            >
                                <div className="flex flex-col">
                                    <div
                                        className="relative w-20 h-20 rounded-full flex items-center justify-center text-white text-3xl font-bold border border-white/15"
                                        style={{
                                            background:
                                                "linear-gradient(135deg, rgba(108,71,255,0.4) 0%, rgba(139,92,246,0.18) 50%, rgba(245,158,11,0.18) 100%)",
                                            boxShadow:
                                                "0 0 0 6px rgba(108,71,255,0.06), 0 20px 50px -20px rgba(108,71,255,0.6)",
                                        }}
                                    >
                                        <span className="dashboard-num">
                                            {s.n}
                                        </span>
                                    </div>
                                    <h3 className="h-display mt-6 text-lg font-semibold text-white">
                                        {s.title}
                                    </h3>
                                    <p className="mt-2 text-white/65 leading-relaxed text-[14.5px]">
                                        {s.text}
                                    </p>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </section>
    );
}
